// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Truncate_wrapper__1i0QQ","ellipsis":"Truncate_ellipsis__apYN3"};